

















































import { defineComponent } from '@vue/composition-api'
import XLSX from 'xlsx'
import ButtonExport from '@/components/ButtonExport.vue'
import { dateLibs } from '@/utils'
import { APP_URL_API } from '@/constants'

export default defineComponent({
  name: 'BirthdayOfMonth',
  components: {
    ButtonExport
  },
  props: {
    employees: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    const URL_PDF = 'reports/birthday'
    const getWithCurrentYear = (date_birth: string) => {
      return dateLibs.setWithCurrentYear(date_birth)
    }

    const print = () => {
      window.open(`${APP_URL_API}${URL_PDF}`, '_blank')
    }

    const headersExcel = [
      { text: 'Apellidos', value: 'apellidos' },
      { text: 'Nombres', value: 'nombres' },
      { text: 'Cumpleaños', value: 'cumpleanos' }
    ]

    const itemsExcel = () => {
      return props.employees.map(item => {
        return {
          apellidos: item.last_name + ' ' + item.mothers_last_name,
          nombres: item.name,
          cumpleanos: getWithCurrentYear(item.date_birth)
        }
      })
    }

    return {
      getWithCurrentYear,
      headersExcel,
      itemsExcel,
      print
    }
  }
})
